import { useEffect, useState } from "react";
import { MealOption } from "../Domain/MealSettings";

interface UseHeaderCheckboxSyncReturn {
  showHeaderChecked: boolean;
  toBeOrderedHeaderChecked: boolean;
  foodFreeHeaderChecked: boolean;
}

/**
 * Custom hook to synchronize header checkboxes with meal options state
 * @param mealOptions - Array of meal options to check
 * @returns Object containing header checkbox states
 */
export const useHeaderCheckboxSync = (
  mealOptions: MealOption[]
): UseHeaderCheckboxSyncReturn => {
  const [showHeaderChecked, setShowHeaderChecked] = useState(false);
  const [toBeOrderedHeaderChecked, setToBeOrderedHeaderChecked] = useState(false);
  const [foodFreeHeaderChecked, setFoodFreeHeaderChecked] = useState(false);

  useEffect(() => {
    const hasOptions = mealOptions.length > 0;

    setShowHeaderChecked(
      hasOptions && mealOptions.every((option) => option.disabled === false)
    );
    setToBeOrderedHeaderChecked(
      hasOptions && mealOptions.every((option) => option.toBeOrdered === true)
    );
    setFoodFreeHeaderChecked(
      hasOptions && mealOptions.every((option) => option.foodFree === true)
    );
  }, [mealOptions]);

  return {
    showHeaderChecked,
    toBeOrderedHeaderChecked,
    foodFreeHeaderChecked,
  };
};
